import { withInstall } from '@ll-plus/utils'

import Slideshow from './src/slideshow.vue'

export const LlSlideshow = withInstall(Slideshow)
export default LlSlideshow
export * from './src/slideshow'

declare module 'vue' {
  export interface GlobalComponents {
    LlSlideshow: typeof Slideshow
  }
}
